export default "__VITE_ASSET__zbUOT$UI__"